import { select } from '@angular-redux/store';
import { Component, ElementRef, forwardRef, Inject, QueryList, Renderer2, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { ItemData } from 'sharedFeatures/form';
import { infoPopUpComponent } from "sharedFeatures/infoPopUp";
import { ScrollComponent } from "sharedFeatures/scroll";
import { XeroCompany } from 'sharedFeatures/sharedModels';
import { NewPlanDataValues } from "sharedFeatures/sharedModels/newPlanDataValues";
import { dialogCreationActions } from "sharedFeatures/store";
import { AuthUtils, CurrencyData } from "sharedFeatures/utils";
import { DateUtils } from 'sharedFeatures/utils/date-utils';
import { SlideSwitcherComponent } from 'sharedGuiSmall/components/slide-switcher';
import { SharedGuiSmallModule } from '../../../../../sharedGuiSmall/sharedGuiSmall.module';
import { MinValuePipe } from '../../../../pipes/minvalue.pipe';
import { SafeHtmlPipe } from '../../../../pipes/safehtml.pipe';
import { NewPlanFormBodyComponent } from '../newplan-body.component';
import { NewPlanInnerForm } from '../newplan-inner.form';
import { NewPlanForm } from '../newplan.form';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'newplan-start-form-body-xero',
    templateUrl: './newplan-start-xero-form-body.component.html',
    styleUrls: ['./newplan-start-xero-form-body.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule, infoPopUpComponent, MinValuePipe, SafeHtmlPipe, forwardRef(() => NewPlanFormBodyComponent), TranslateModule]
})
export class NewPlanStartXeroFormBodyComponent extends NewPlanInnerForm {

    enterPlanNameFieldMustBeCompleted = $localize`The "Enter Plan Name" field must be completed`;
    blankText = $localize`blank`
    standardBusinessTemplate = $localize`standard business template`;
    previous12MonthsText = $localize`Previous 12 months`;
    repeatLastMonthText = $localize`Repeat the last month`;
    blankEnterManuallyText = $localize`Blank - enter manually`;
    offTaxText = $localize`Off`;
    VATTaxText = $localize`VAT`;
    salesTaxText = $localize`Sales Tax`;
    GSTTAXText = $localize`GST`;
    forecastStartDateText = $localize`FORECAST_START_DATE_AND`;
    taxSystemLogoText = $localize`TAX_SYSTEM`;
    xeroHistoricalDataLabelText = $localize`FILL_YOUR_FORECAST_BY`;

    monthsComboItems: Array<ItemData> = new DateUtils().monthsComboItems;
    actualsMonthsComboItems: Array<ItemData> = [];

    years: Array<ItemData> = [];

    onOrOffByDefault: Array<ItemData> = [
        { id: 'off', value: this.offTaxText, disabled: false },
        { id: 'vat', value: this.VATTaxText, disabled: false },
        { id: 'salesTax', value: this.salesTaxText, disabled: false },
        { id: 'gst', value: this.GSTTAXText, disabled: false }
    ];

    isBlankPlan: boolean = true;
    isUseCompanyData: boolean = true;

    errorMessage: string = "";
    currencyItems: Array<ItemData> = [];

    durationYear: string = "1";
    currentMonthIndex: number;

    isActualsStartDateChanged: boolean = false;
    skipOnStartPlanDataChange: boolean = false;
    @ViewChild(NgForm)
    private form!: NgForm;

    @ViewChild('controlsSibling', { read: ViewContainerRef })
    private controlsSiblingVCR!: ViewContainerRef;

    @select(['appData', 'appComponent'])
    readonly appComponent$!: Observable<any>;
    
    comboItems: Array<ItemData> = [
        { id: 0, value: this.previous12MonthsText, disabled: false },
        { id: 1, value: this.repeatLastMonthText, disabled: false },
        { id: 2, value: this.blankEnterManuallyText, disabled: false }
    ];

    data: NewPlanDataValues = new NewPlanDataValues();

    @ViewChild('forecastSwitch')
    forecastSlideSwitcher: SlideSwitcherComponent | undefined;

    @ViewChild('tableDiv')
    private tableDiv!: ElementRef;

    @ViewChildren(infoPopUpComponent)
    private infoPopupItems: QueryList<infoPopUpComponent> | undefined = undefined;

    parent: NewPlanForm;


    constructor(
        el: ElementRef,
        r: Renderer2,
        @Inject(forwardRef(() => NewPlanForm)) parent: NewPlanForm
    ) {        
        super(el, r);
        let d = new Date();
        
        this.getNewPlanData();
        let currentYear = d.getFullYear();
        this.currentMonthIndex = d.getMonth();

        dialogCreationActions.setNewPlanDialogOpen(true);
        this.parent = parent;

        const isExtendMinPlanStartDate = AuthUtils.isBetaFeatureActive(this.parent.authData, 'ExtendMinPlanStartDate');

        for (let i = isExtendMinPlanStartDate ? -10 : -3; i < 11; i++) {
            this.yearComboItems.push({ id: i, value: (currentYear + i).toString(), disabled: false });
        }

        this.newPlan.aTemplateName = this.standardBusinessTemplate;

        this.parent.testId = 'newPlan';

        // fill CurrencyItems
        CurrencyData.currencies.forEach((item) => {
            let iData = new ItemData();
            iData.disabled = false;
            iData.id = item[0];
            iData.value = item[1];

            this.currencyItems.push(iData);
        });
        
    }

    notAllAdjustsBlank(): boolean {
        return this.data.salesValue !== 2 || this.data.costsValue !== 2 || this.data.salariesValue !==2 || this.data.expensesValue !==2;
    }

    isNotBlank(dataVal: number): boolean {
        return dataVal !== 2;
    }

    getForm(): NgForm {
        return this.form;
    }

    public isSaveClosePaneHidden(): boolean {
        return true;
    }

    aVatText: string = 'off';

    countPlans(): number {
        let N = 0;
        let containsNumbers: boolean = false;

        console.log('plans ', this.parent.plans);

        for (let plan of this.parent.plans) {

            let planNameNewSymbols = plan.planname.replace(/\s/g, "").replace(/[0-9]/g, '');
            if (this.newPlan.planName.replace(/\s/g, "").indexOf(planNameNewSymbols) >= 0) {
                let i = plan.planname.match(/\d/g);

                if (this.newPlan.planName.replace(/\s/g, '').replace(/[0-9]/g, '').toLowerCase() == plan.planname.replace(/\s/g, '').replace(/[0-9]/g, '').toLowerCase()) {
                    
                    if (i != null) {
                        containsNumbers = true;
                        let iString = i.join("");
                        let vNumber = parseInt(iString);
                        if (vNumber > N) {
                            N = vNumber;
                        }
                    } else {
                        if (N == 0) {
                            N++;
                        }
                    }

                }
            }
        }

        if (N > 0) {
            if (containsNumbers)
                N++;
        }

        return N;
    }

    ngAfterViewInit() {

        this.newPlan.currencyId = this.parent.authData.lastCurrencyId;

        // Last selected tax system
        if (this.parent.authData.lastTaxSystem &&
            this.onOrOffByDefault.some(x => x.id === this.parent.authData.lastTaxSystem))
            this.aVatText = this.parent.authData.lastTaxSystem;

        if (this.parent.authData.xeroAuthOptions.isRedirectedFromXero) {
            //this.getNewPlanData(this.parent.authData.xeroAuthOptions);
            this.ngOnChanges();
        }

        if (this.forecastSlideSwitcher && this.forecastSlideSwitcher.getValue()) this.r.setStyle(this.tableDiv.nativeElement, 'display', '');
        else this.r.setStyle(this.tableDiv.nativeElement, 'display', 'none');
        
        this.calcActualsStartDate();
    }

    ngOnChanges() {

        if (this.parent.authData != null && !this.years.length) {
            this.years = this.parent.authData.planDurationYears.filter(x => !x.disabled);

            if (this.parent.authData.licenseStatus == "Trial" || this.parent.authData.level >= 2) {
                if (this.years.some(x => x.id == 3 && !x.disabled))
                    this.durationYear = "3";
            }
        }

    }

    ngOnDestroy(): void {
        dialogCreationActions.setNewPlanDialogOpen(false);
    }

    onStartPlanDataChange() {

        if (this.skipOnStartPlanDataChange)
            return;

        this.calcActualsStartDate();

    }
    
    toggleBlankPlan(value: boolean) {
        this.isBlankPlan = value;
        this.newPlan.aTemplateName = this.isBlankPlan ? this.standardBusinessTemplate : this.blankText;
    }

    toggleUseCompany(value: boolean) {
        this.isUseCompanyData = value;
    }

    onInputTextChange(event: string) {
        if (event == "")
            this.errorMessage = this.enterPlanNameFieldMustBeCompleted;
        else
            this.errorMessage = "";
    }

    public setNewPlanData() {
        let newPlanData =
        {
            planName: this.newPlan.planName,
            month: this.monthString,
            startYearString: this.ForecastStartYear,
            actualsMonth: this.actualsMonthString,
            actualsStartYearString: this.ActualsStartYear,
            durationYear: this.durationYear,
            yearEndMonth: this.newPlan.yearEndMonth,
            currencyString: this.newPlan.currencyId.toString(),
            aVatText: this.aVatText,
            isBlankPlan: this.isBlankPlan,
            importData: this.data
        };

        localStorage.setItem('newPlanData', JSON.stringify(newPlanData));
    }

    public getNewPlanData() {

        let newPlanData = localStorage.getItem('newPlanData');

        if (newPlanData) {
            let jNewPlanData = JSON.parse(newPlanData);
            this.durationYear = jNewPlanData.durationYear + '';            
            this.aVatText = jNewPlanData.aVatText;
            this.toggleBlankPlan(jNewPlanData.isBlankPlan);
            this.newPlan.planName = jNewPlanData.planName;

            this.newPlan.yearEndMonth = jNewPlanData.yearEndMonth;            
        }
    }

    public getControlsViewContainerRef(): ViewContainerRef {
        return this.controlsSiblingVCR;
    }

    getPercentFieldDisplayValue(originalVal: string): string {

        return originalVal + '%';

    }

    closeOtherInfoPanels(id: string) {
        if (!this.infoPopupItems) return;
        
        this.infoPopupItems.forEach(x => {
            if (x.pFieldID !== id)
                x.close();
        });
    }

    public onGoOut(callback?: Function): void {
        this.setNewPlanData();
        if (callback) callback();
    }

    public getScrollPane(): ScrollComponent {
        throw new Error("Method not implemented.");
    }
    public saveClosePanePlaceEl(): Element {
        throw new Error("Method not implemented.");
    }

    public reload(callback: Function): void {}

    onSwitchForecast() {
        const tableEl = this.tableDiv.nativeElement;
        if (getComputedStyle(tableEl).display === 'block') this.r.setStyle(tableEl, 'display', 'none');
        else this.r.setStyle(tableEl, 'display', '');
    }

    onClose() {
        this.parent.showSetupWarning();
    }

    public UpdateNewPlanData(company: XeroCompany) {
        this.newPlan.planName = company.name;
        this.newPlan.currencyId = company.currencyId;
        this.newPlan.yearEndMonth = company.yearEnd;

        let N = this.countPlans();
        if (N > 0)
            this.newPlan.planName += ' ' + N;
    }
}